import { RootState } from "core-integration/src/store";
import { getElement } from "core-integration/src/store/elements/reducers";
import { getFixturesStatusForTeamInEvent } from "core-integration/src/store/fixtures/reducers";
import { useSelector } from "react-redux";
import ElementPoints, { ElementPointsProps } from "../../ElementPoints";
import ElementDetailsBar from "../ElementDetailsBar";
import { getElementDetailsBarVariant } from "./utils";

const ElementCardPoints = ({ eventId, pick }: ElementPointsProps) => {
  const element = useSelector((state: RootState) =>
    getElement(state, pick.element),
  );
  const fixturesStatus = useSelector((state: RootState) =>
    getFixturesStatusForTeamInEvent(state, eventId, element.team),
  );

  return (
    <ElementDetailsBar variant={getElementDetailsBarVariant(fixturesStatus)}>
      <ElementPoints eventId={eventId} pick={pick} />
    </ElementDetailsBar>
  );
};

export default ElementCardPoints;
